import { AnamnesisService } from './AnamnesisService'

import { appConfig } from 'Config'

export const anamnesisService = new AnamnesisService({ baseURL: appConfig.anamnesisService.baseUrl })
